import { createSlice } from "@reduxjs/toolkit";

const savedAuthState =JSON.parse(sessionStorage.getItem("auth"))|| {
  userId: null,
  token: null,
  isLoggedIn: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState:savedAuthState,
  reducers: {
    login: (state, action) => {
      state.userId = action.payload.userId;
      state.token = action.payload.token;
      state.isLoggedIn = true;
      sessionStorage.setItem("auth", JSON.stringify(state));
    },
    logout: (state) => {
      state.userId = null;
      state.token = null;
      state.isLoggedIn = false;
      sessionStorage.removeItem("auth");
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
